import { memo } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Status = ({ color = 'inherit', label, sx, labelSx }) => {
  return (
    <Box sx={{ flexShrink: 0, display: 'inline-flex', alignItems: 'center', ...sx }}>
      <Box component='span' sx={{ backgroundColor: color, flexShrink: 0, width: '8px', height: '8px', borderRadius: '50%', mr: '4px'}} />
      <Typography variant='body2' component='div' sx={{ fontWeight: 500, whiteSpace: 'nowrap', ...labelSx }}>{label}</Typography>
    </Box>
  );
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Status {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);